var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`split-content ${_vm.hideAuxiliar ? 'split-content__single' : ''}`},[(!_vm.hideAuxiliar)?_c('div',[_vm._t("auxiliar")],2):_vm._e(),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }